import clients from '../../../data/clients';

export default {

  slug: 'module-test-page',

  company: clients.dreamworks.name,
  logo: clients.dreamworks.logo,
  logoWhite: clients.dreamworks.logoWhite,

  blurb: {
    headline: "Designing a digital storytelling adventure.",
    tags: [],
    byline: 'Learn more about our work with Dreamworks',
    background: require('./assets/preview.jpg'),
    backgroundSet: [
      {
        max: 1024,
        src: require('./assets/preview-mobile.jpg'),
      },
    ],
  },

  modules: [
    {
      type: 'work-header',

      data: {
        background: require('./assets/hero.jpg'),
        title: 'Work Header – Where Kids Become the Directors of Their Own Movies.',
        content: 'DreamWorks has developed an entire website aimed at inspiring kids to express their creativity (http://create.dreamworks.com/). The site is filled with options for fashioning crafts and paper toys, bringing DreamWorks characters to life through augmented reality, making scrapbooks, learning art techniques, and more.\n\nWhen DreamWorks got in touch with Particle Design, they were looking to add a video and storytelling element to the site. They wanted an activity that would empower kids to feel like they were directing their own movies. They envisioned kids choosing characters, making storyline decisions, and writing the simple scripts that would drive the narrative. They also wanted the final video each child created to convert immediately into a black-and-white comic book that kids could print and color.',
        roles: [
          'UX Strategy',
          'Interaction Design',
          'Visual Design',
          'Front-End Development',
          'Back-End Development',
        ],
      },
    },

    {
      type: 'work-image-text-column',

      data: {
        reversed: false,
        image: {
          src: require('./assets/dragon-racers.jpg'),
          alt: 'Image of Toothless from Dreamworks\' "How to Train Your Dragon"',
          hAlign: 'left', // left, center, right
          vAlign: 'top', // top, center, bottom
        },
        content: {
          text: '## Image Text Column – not reversed.\n\nno caption on image. content aligned left. creativity (http://create.dreamworks.com/). The site is filled with options for fashioning crafts and paper toys, bringing DreamWorks characters to life through augmented reality, making scrapbooks, learning art techniques, and more.',
          hAlign: 'left',  // left, right
        },
      },
    },

    {
      type: 'work-image-text-column',

      data: {
        reversed: false,
        image: {
          src: require('./assets/dragon-racers.jpg'),
          alt: 'Image of Toothless from Dreamworks\' "How to Train Your Dragon"',
          hAlign: 'left', // left, center, right
          vAlign: 'top', // top, center, bottom
        },
        content: {
          text: '## Image Text Column – not reversed.\n\nno caption on image. content aligned right. (http://create.dreamworks.com/). The site is filled with options for fashioning crafts and paper toys, bringing DreamWorks characters to life through augmented reality, making scrapbooks, learning art techniques, and more.',
          hAlign: 'right',  // left, right
        },
      },
    },

    {
      type: 'work-image-text-column',

      data: {
        reversed: true,
        image: {
          src: require('./assets/dragon-racers.jpg'),
          alt: 'Image of Toothless from Dreamworks\' "How to Train Your Dragon"',
          hAlign: 'left', // left, center, right
          vAlign: 'top', // top, center, bottom
        },
        content: {
          text: '## Image Text Column – reversed.\n\ncontent aligned left. their creativity (http://create.dreamworks.com/). The site is filled with options for fashioning crafts and paper toys, bringing DreamWorks characters to life through augmented reality, making scrapbooks, learning art techniques, and more.',
          hAlign: 'left',  // left, right
        },
      },
    },

    {
      type: 'work-image-text-column',

      data: {
        reversed: true,
        image: {
          src: require('./assets/dragon-racers.jpg'),
          alt: 'Image of Toothless from Dreamworks\' "How to Train Your Dragon"',
          hAlign: 'left', // left, center, right
          vAlign: 'top', // top, center, bottom
        },
        content: {
          text: '## Image Text Column – reversed.\n\ncontent aligned right (http://create.dreamworks.com/). The site is filled with options for fashioning crafts and paper toys, bringing DreamWorks characters to life through augmented reality, making scrapbooks, learning art techniques, and more.',
          hAlign: 'right',  // left, right
        },
      },
    },

    {
      type: 'work-image-text-row',

      data: {
        reversed: false,
        image: {
          src: require('./assets/dragon-racers.jpg'),
          alt: 'Image of Toothless from Dreamworks\' "How to Train Your Dragon"',
          hAlign: 'left', // left, center, right
          vAlign: 'top', // top, center, bottom
        },
        content: '## Image Text Row – not reversed.\n\nno caption on image. aimed at inspiring kids to express their creativity (http://create.dreamworks.com/). The site is filled with options for fashioning crafts and paper toys, bringing DreamWorks characters to life through augmented reality, making scrapbooks, learning art techniques, and more.',
      },
    },

    {
      type: 'work-image-text-row',

      data: {
        reversed: true,
        image: {
          src: require('./assets/dragon-racers.jpg'),
          alt: 'Image of Toothless from Dreamworks\' "How to Train Your Dragon"',
          caption: 'Image of Toothless from Dreamworks\' "How to Train Your Dragon"',
        },
        content: '>Image Text Row – reversed. bad-ass caption included. on your face scratch the furniture damn that dog meow to be let in. Cat not kitten around. Cats are fats I like to pets them they like to meow back meow.\n\n>> Kat Sutton\nUX Lead, Particle',
      },
    },

    {
      type: 'work-image-text-row',

      data: {
        reversed: false,
        image: {
          src: require('./assets/dragon-racers.jpg'),
          alt: 'Image of Toothless from Dreamworks\' "How to Train Your Dragon"',
          caption: 'Image of Toothless from Dreamworks\' "How to Train Your Dragon"',
        },
        content: '## Hello there, it\'s me again\n\nImage Text Row – this time just a tiny bit of text we will want to center as well. We like balance.',
      },
    },

    {
      type: 'work-two-column-text',

      data: {
        reversed: false,
        contentLeft: '## Two Col Text – not reversed, but gotta get this to two lines.\n\nFor this DreamWorks project, Particle had limited time—less than 60 days—and a tight budget. There were also complex restrictions and guidelines about how DreamWorks characters could be used in the experience in order to maintain brand authenticity.\n\nAnd most significantly, since the site was for young children, it was critical that the content maintained compliance with COPPA (Children’s Online Privacy Protection Act), under U.S. federal law. COPPA’s primary goal is to place parents in control of the information collected from their children online. As such, it imposes regulations on websites focused on children under 13. Its requirements are stringent, and Particle’s team had to ensure there was no deviation as design decisions were made throughout the project.',

        contentRight: '>Building an experience that allows kids to take an active role in creating the content they consume every day was an exciting opportunity.\n\n>> Stacey Rutland\nParticle, Project Lead',
      },
    },

    {
      type: 'work-two-column-text',

      data: {
        reversed: true,
        contentLeft: '## Two Col Text – reversed, but gotta get this to two lines.\n\nFor this DreamWorks project, Particle had limited time—less than 60 days—and a tight budget. There were also complex restrictions and guidelines about how DreamWorks characters could be used in the experience in order to maintain brand authenticity.\n\nAnd most significantly, since the site was for young children, it was critical that the content maintained compliance with COPPA (Children’s Online Privacy Protection Act), under U.S. federal law. COPPA’s primary goal is to place parents in control of the information collected from their children online. As such, it imposes regulations on websites focused on children under 13. Its requirements are stringent, and Particle’s team had to ensure there was no deviation as design decisions were made throughout the project.',

        contentRight: '>Building an experience that allows kids to take an active role in creating the content they consume every day was an exciting opportunity.\n\n>> Stacey Rutland\nParticle, Project Lead',
      },
    },

    {
      type: 'work-multi-image-text',

      data: {
        reversed: false,
        images: [
          {
            src: require('./assets/office-discussion.jpg'),
          },
          {
            src: require('./assets/boy-head.jpg'),
            hAlign: 'center', // left, center, right
            vAlign: 'bottom', // top, center, bottom
          },
        ],
        content: '## Multi Image Text – not reversed - two images.\n\nDreamWorks wanted to give kids a great storytelling experience as directors of their own movie scenes. Particle was keen to bring their idea to life but quickly identified the project’s central challenge. The objective was to give children the freedom to create their own stories and have an output when finished. But if there were too many options, the rendering process would take so long kids would give up before the final video could be created. On the other hand, if there weren’t enough options, the activity would be boring and fail to inspire.\n\nParticle’s developers knew the complexity that video brings to web apps and the requirements for success. We were able to help the whole project team understand what would and would not work and kept the project on track. In the end, the video activity we developed struck the perfect balance between creativity and functionality.',
      },
    },

    {
      type: 'work-multi-image-text',

      data: {
        reversed: true,
        images: [
          {
            src: require('./assets/office-discussion.jpg'),
          },
          {
            src: require('./assets/boy-head.jpg'),
          },
        ],
        content: '## Multi Image Text – reversed - two images.\n\nDreamWorks wanted to give kids a great storytelling experience as directors of their own movie scenes. Particle was keen to bring their idea to life but quickly identified the project’s central challenge. The objective was to give children the freedom to create their own stories and have an output when finished. But if there were too many options, the rendering process would take so long kids would give up before the final video could be created. On the other hand, if there weren’t enough options, the activity would be boring and fail to inspire.\n\nParticle’s developers knew the complexity that video brings to web apps and the requirements for success. We were able to help the whole project team understand what would and would not work and kept the project on track. In the end, the video activity we developed struck the perfect balance between creativity and functionality.',
      },
    },

    {
      type: 'work-multi-image-text',

      data: {
        reversed: false,
        images: [
          {
            src: require('./assets/office-discussion.jpg'),
          },
          {
            src: require('./assets/boy-head.jpg'),
          },
          {
            src: require('./assets/camera.jpg'),
          },
        ],
        content: '## Multi Image Text – not reversed - three images.\n\nDreamWorks wanted to give kids a great storytelling experience as directors of their own movie scenes. Particle was keen to bring their idea to life but quickly identified the project’s central challenge. The objective was to give children the freedom to create their own stories and have an output when finished. But if there were too many options, the rendering process would take so long kids would give up before the final video could be created. On the other hand, if there weren’t enough options, the activity would be boring and fail to inspire.\n\nParticle’s developers knew the complexity that video brings to web apps and the requirements for success. We were able to help the whole project team understand what would and would not work and kept the project on track. In the end, the video activity we developed struck the perfect balance between creativity and functionality.',
      },
    },

    {
      type: 'work-multi-image-text',

      data: {
        reversed: true,
        images: [
          {
            src: require('./assets/office-discussion.jpg'),
          },
          {
            src: require('./assets/boy-head.jpg'),
          },
          {
            src: require('./assets/camera.jpg'),
          },
        ],
        content: '## Multi Image Text – reversed - three images.\n\nDreamWorks wanted to give kids a great storytelling experience as directors of their own movie scenes. Particle was keen to bring their idea to life but quickly identified the project’s central challenge. The objective was to give children the freedom to create their own stories and have an output when finished. But if there were too many options, the rendering process would take so long kids would give up before the final video could be created. On the other hand, if there weren’t enough options, the activity would be boring and fail to inspire.\n\nParticle’s developers knew the complexity that video brings to web apps and the requirements for success. We were able to help the whole project team understand what would and would not work and kept the project on track. In the end, the video activity we developed struck the perfect balance between creativity and functionality.',
      },
    },

  ],
};



// WEBPACK FOOTER //
// ./src/content/work/module-test-page/index.js